<template>
  <div class="flex text-root md:justify-between">
    <div class="flex flex-auto items-center justify-between md:justify-start">
      <div class="order-last flex items-center space-x-4 md:order-first">
        <label class="radio">
          <input type="radio" name="layout" value="LARGE" v-model="layout" />
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            focusable="false"
            aria-hidden="true"
          >
            <rect x="0" y="0" width="100%" height="100%" fill="currentColor" />
          </svg>
          <span class="sr-only">Layout 1</span>
        </label>

        <label class="radio">
          <input type="radio" name="layout" value="NORMAL" v-model="layout" />
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            focusable="false"
            aria-hidden="true"
          >
            <rect x="0" y="0" width="7" height="7" fill="currentColor" />
            <rect x="10" y="0" width="7" height="7" fill="currentColor" />
            <rect x="0" y="10" width="7" height="7" fill="currentColor" />
            <rect x="10" y="10" width="7" height="7" fill="currentColor" />
          </svg>
          <span class="sr-only">Layout 2</span>
        </label>

        <label class="radio">
          <input type="radio" name="layout" value="LIST" v-model="layout" />
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            focusable="false"
            aria-hidden="true"
          >
            <rect x="0" y="0" width="100%" height="2" fill="currentColor" />
            <rect x="0" y="5" width="100%" height="2" fill="currentColor" />
            <rect x="0" y="10" width="100%" height="2" fill="currentColor" />
            <rect x="0" y="15" width="100%" height="2" fill="currentColor" />
          </svg>
          <span class="sr-only">Layout 3</span>
        </label>
      </div>

      <div
        class="mr-4 flex flex-auto items-center whitespace-nowrap md:ml-4 md:mr-0 md:flex-grow-0"
      >
        <label for="order-by" class="md:hidden">
          {{ t('sort') }}
        </label>
        <label for="order-by-large" class="hidden md:inline">
          {{ t('sort_by') }}
        </label>
        &nbsp;
        <span class="select flex-auto">
          <select
            id="order-by"
            name="sort-by"
            class="w-full font-semibold"
            v-model="sort"
          >
            <option
              v-for="option in options"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </span>
      </div>
    </div>
    <button
      class="button-filter hidden md:inline"
      @click="toggleFilter"
      :aria-pressed="filterVisible ? 'true' : 'false'"
    >
      {{ t('filter_toggle_label') }}
    </button>
  </div>
</template>

<i18n>
{
  "en": {
    "sort_by": "Sort by",
    "sort": "Sort",
    "title": "Title",
    "relevance": "Relevance",
    "date": "Date",
    "ascending": "ascending",
    "descending": "descending",
    "last_modified": "Last modified",
    "filter_toggle_label": "Detailed search"
  },
  "de": {
    "sort_by": "Sortieren nach",
    "sort": "Sortieren",
    "title": "Titel",
    "relevance": "Relevanz",
    "date": "Datum",
    "ascending": "aufsteigend",
    "descending": "absteigend",
    "last_modified": "Zuletzt geändert",
    "filter_toggle_label": "Detailsuche"
  }
}
</i18n>

<script lang="ts">
import { defineComponent, getCurrentInstance } from 'vue';
import { filterVisible, layout, sort, toggleFilter } from '../utils/filter';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  setup() {
    const { t } = useI18n();
    const instance = getCurrentInstance();
    const options = [
      { value: 'RELEVANCE', label: t('relevance') },
      { value: 'TITLE_ASC', label: `${t('title')} A—Z` },
      { value: 'TITLE_DES', label: `${t('title')} Z—A` },
      { value: 'DATE_ASC', label: `${t('date')} ${t('ascending')}` },
      { value: 'DATE_DES', label: `${t('date')} ${t('descending')}` },
      { value: 'LAST_EDITED_DES', label: t('last_modified') },
    ];

    return { filterVisible, toggleFilter, sort, layout, options, t };
  },
});
</script>
